import { Aurelia, Container, autoinject } from 'aurelia-framework';
import { HttpClient, HttpResponseMessage } from 'aurelia-http-client';

import { BaseAdapter } from 'Common/BaseAdapter';
import { Config } from 'Config';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { inject } from 'aurelia-dependency-injection';
import { AuthInterceptor } from 'Config';

@autoinject
export class RESTApiAdapter extends BaseAdapter {

    constructor(httpClient: HttpClient, i18n: I18N, authInterceptor: AuthInterceptor) {
        super(httpClient, i18n, authInterceptor);
    }


    public async Execute(body: any): Promise<any> {
        let methodName = Object.keys(body);
        body['RequestGuid'] = GuidHelper.NewGuid();
        body['RequestDatetime'] = new Date();
        body['Version'] = '3.0.0.0.0000.0000';
        body['Device'] = await this.GetDevice();
        body['Culture'] = this.i18n.getLocale().toLowerCase();

        return await this.httpClient.post(Config.ApiUrl() + '/Execute?' + (methodName.length > 0 ? methodName[0] : 'undefined'), JSON.stringify(body))
            .then(response => {
                if (response.isSuccess) {
                    let responseData = null;
                    try {
                        responseData = JSON.parse(response.content);
                    } catch (e) {
                        responseData = response.content;
                    }
                    switch (responseData['status']) {
                        case 'Error': {
                            //window.location.href = '#/error';
                            return responseData;
                        };
                        case 'Warning': {
                            return responseData;
                        }
                        case 'Unauthorized': {
                            if (methodName.length > 0 && methodName[0] == 'GetGridCountParam') {
                                return responseData;
                            }
                            else {
                                window.location.hash = '#/unauthorized';
                            }

                        } break;
                        case 'Unauthenticated': {
                            localStorage.removeItem(Config.TokenName());
                            location.reload();
                        } break;

                        case 'LoginTemporarilyBlocked':
                        case 'LoginPermanentlyBlocked':
                        case 'InvalidLogin':
                        case 'InvalidJson': {
                            return responseData;
                        }
                        case 'OK': {
                            return responseData;
                        }
                    }

                }
                return null;
            });
    }

    public async GridExport(body: any): Promise<HttpResponseMessage> {
        body['RequestGuid'] = GuidHelper.NewGuid();
        body['RequestDatetime'] = new Date();
        body['Version'] = '3.0.0.0.0000.0000';
        body['Device'] = await this.GetDevice();
        body['Culture'] = this.i18n.getLocale().toLowerCase();

        if (!StringHelper.IsNullOrEmptyOrUndefined(localStorage[Config.TokenName()]) && localStorage[Config.TokenName()] != null) {
            body['UserToken'] = JSON.parse(localStorage[Config.TokenName()] || null).Token;
        }
        else {
            body['UserToken'] = null;
        }
        return await this.httpClient.createRequest(Config.ApiUrl() + "/Execute")
            .asPost()
            .withContent(JSON.stringify(body))
            .withResponseType("arraybuffer")
            .send()
            .then(response => {
                if (response.isSuccess) {
                    return response;
                }
                window.location.href = '#/error';
                return null;
            });

    }

    // POST AddEmailAttachment(int emailId, string userToken)
    // POST DeleteEmailAttachment(int attachmentId, string userToken)
    // GET DownloadEmailAttachment(int attachmentId, string userToken)
    // POST SetIsRead(int emailId, bool read, string userToken)
    // POST SetIsFlagged(int emailId, bool flagged, string userToken) 

    public async ExecuteWithouContent(apiAction: string, urlQueryStringParameters: string): Promise<HttpResponseMessage> {
        return await this.httpClient.createRequest(Config.ApiUrl() + "/" + apiAction + urlQueryStringParameters)
            .asPost()
            .skipContentProcessing()
            .send();
    }

    public async ExecuteWithouContentProcessing(apiAction: string, requestContent: any, urlQueryStringParameters: string): Promise<HttpResponseMessage> {
        return await this.httpClient.createRequest(Config.ApiUrl() + "/" + apiAction + urlQueryStringParameters)
            .asPost()
            .withContent(requestContent)
            .skipContentProcessing()
            .send();
    }

    public async ExecuteWithouContentProcessingWithoutTimeout(apiAction: string, requestContent: any, urlQueryStringParameters: string): Promise<HttpResponseMessage> {
        return await this.httpClient.createRequest(Config.ApiUrl() + "/" + apiAction + urlQueryStringParameters)
            .asPost()
            .withContent(requestContent)
            .withTimeout(10000000)
            .skipContentProcessing()
            .send();
    }
    public async IsMobileDevice1() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }
    public async IsMobileDevice2() {
        return window.matchMedia("(any-hover:none)").matches == true;
    }

    public GetLocale(): string {
        const userInfo = JSON.parse(localStorage[Config.TokenName()] || null);
        return userInfo['UserLanguage'].substring(0, 2);
    }

    public async GetNavigatorUserAgent(): Promise<string> {

        return navigator.userAgent;
    }

    public async GetDevice(): Promise<string> {

        // get uset agent
        let ua = navigator.userAgent.toLowerCase();

        // check if ua is tablet
        if (/(ipad | tablet | (android(?!.*mobile)) | (windows(?!.*phone)(.*touch)) | kindle | playbook | silk | (puffin(?!.*(IP | AP | WP)))) /.test(ua)) {
            return 'Tablet';
        }
        // check if ua is phone
        else if (/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua)) {
            return 'Phone';
        }
        // ua is desktop
        else {
            return 'Desktop';
        }
    }



}



